import React from 'react';
import { ModalAlterarPrecoAtacado } from '../../../../../components';
import { ModalClearWholesaleFields } from '../ModalClearWholesaleFields';

const PrecoAtacadoModalsWrapper = () => {
  return (
    <>
      <ModalAlterarPrecoAtacado />
      <ModalClearWholesaleFields />
    </>
  );
};

export default PrecoAtacadoModalsWrapper;
